module.exports = __webpack_public_path__ + "static/story3-02-533x800-59a07da42151f27cd2f3df2a5040f97c.jpg";